import React from "react";
import UserOrderComponent from "../components/order-history/SingleOrder";

export default function UserSingleOrderPage() {
  return <UserOrderComponent />;
}
